import { InstanceConstants } from "./InstanceConstants";

export const constants: InstanceConstants = {
    appInsightsConnectionString: "<cc1cde06-5b64-4437-973c-65126dc5389e>"
};